<template>
  <div class="table-wrapper">
    <b-table
      striped
      hover
      :items="vendorList"
      :fields="fields"
      @row-clicked="goToVendor"
    ></b-table>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'VendorList',
  components: {},
  props: {
    vendors: {
      type: Array,
      required: true,
    },
    optionalFields: {
      type: Object,
      default: function () {
        return {}
      },
    },
  },
  data: function () {
    const id = _.random(0, 9999999)
    return {
      id: id,
      fields: [
        {
          key: 'name',
          class: ['clickable-row'],
          sortable: true,
        },
        {
          key: 'email',
          class: ['clickable-row'],
          sortable: true,
        },
        {
          key: 'phone',
          class: ['clickable-row'],
          sortable: true,
        },
      ],
    }
  },
  mounted() {},
  computed: {
    vendorList() {
      return this.vendors.map(vendor => {
        const { name, email, phone, id } = vendor
        return { name, email, phone, id }
      })
    },
  },
  methods: {
    goToVendor(vendor, index, e) {
      if (e.metaKey) {
        window.open('/app/vendors/' + vendor.id, '_blank')
      } else {
        this.$router.push('/app/vendors/' + vendor.id)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@media print {
  .table-wrapper {
    max-height: inherit;
    overflow: auto;
  }
}
</style>

<style>
.clickable-row {
  cursor: pointer;
}
</style>
